import React, { useState, useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import { useHistory } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { IndirectStylesInvoice } from './IndirectStyles'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import 'react-toastify/dist/ReactToastify.css'
import * as IndirectActions from '../../actions/indirects/IndirectActions'
import { bindActionCreators } from 'redux'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as navigationActions from '../../actions/common/NavigationActions'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'

const IndirectAssingSupplier = ({ classes, ...props }) => {
    const history = useHistory()
    const { match: { params } } = props
    const [branchOfficeId, setBranchOfficeId] = useState('');
    const [disabledButton, setDisabledButton] = useState(true)
    const [disabledMenuItems, setDisabledMenuItems] = useState(false)
    const [openBackdrop, setOpenBackdrop] = useState(false)

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/indirect/AssingSupplier',
            linkLegend: 'Asignar proveedor',
            urlParams: [{ key: 'orderId', value: params.orderId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Order_Detail(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        props.actions.fetch_Branch_Office_list(props.userLanguage, props.userToken, onError, onSuccessFetch)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccessFetch = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const handleChange = (event) => {
        event.target.value === '' ? setDisabledButton(true) : setDisabledButton(false)
        setBranchOfficeId(event.target.value)
    };

    const Send = () => {
        if (branchOfficeId !== '') {
            handleOpenBackdrop()
            props.actions.Add_Branch_Office_To_Order(props.userLanguage, props.userToken, branchOfficeId, params.orderId, onError, onSuccess)
        } else {
            toast.error('Debe de seleccionar un proveedor', { className: classes.toastError })
        }
    }

    const onSuccess = (response) => {
        handleCloseBackdrop()
        if (response) {
            toast.success('Se agregó correctamente la sucursal', { className: classes.toastSuccess })
            setDisabledButton(true)
            setDisabledMenuItems(true)
        }
        else {
            toast.error('Ocurrió un error al agregar la sucursal', { className: classes.toastError })
        }
    }

    return (
        <div>
            <TopBarNav />
            <br />

            <Container maxWidth="lg" >
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container>
                    <Grid item xs={4} style={{ marginLeft: '-25px' }}>
                        <BreadcrumbsHistory />
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="lg" className={classes.root}>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h5>Asignar proveedor a la orden</h5>
                        <h6>Número de la PO: {props.orderDetail.poNumber}</h6>
                        <br />
                    </Grid>
                </Grid>

                <Grid container item xs={11} className={classes.ContainerBorder} >
                    <Grid item xs={2}></Grid>
                    <Grid item xs={8} >
                        <Container maxWidth="lg" >
                            <Grid item xs={12} style={{ textAlign: 'center', paddingTop: '50px' }}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Sucursal</InputLabel>
                                    <Select
                                        id=""
                                        value={branchOfficeId}
                                        onChange={handleChange}
                                        label="Sucursal"
                                        disabled={disabledMenuItems}
                                    >
                                        <MenuItem value="">
                                            <em>Ningúno</em>
                                        </MenuItem>
                                        {
                                            props.BranchOfficeList.map((item, index) => (
                                                <MenuItem key={index} value={item.id}>{item.description}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: 'center', paddingTop: '50px' }}>
                                <Grid container item xs={12}>
                                    <Grid item xs={7}></Grid>
                                    <Grid item xs={5}>
                                        <ButtonGroup disableElevation variant="contained" size="small" disabled={disabledButton} aria-label="small outlined button group">
                                            <Button type="button" className={classes.ButtonSave} variant="outlined" onClick={Send}>Asignar</Button>
                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <br />
                            <br />
                        </Container>
                    </Grid>
                    <Grid item xs={2}></Grid>
                </Grid>
            </Container>

            <ToastContainer />
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listHistory: state.IndirectReducer.historyList,
    orderDetail: state.IndirectReducer.orderDetail,
    BranchOfficeList: state.IndirectReducer.BranchOfficeList,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(IndirectActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(IndirectStylesInvoice)(IndirectAssingSupplier))
